// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"29b7cb48","183":"439cc75b","296":"84e2c968","355":"e3f4926c","822":"514445a0"}[chunkId] + ".chunk.js";
};